import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ObjectStatuses } from '@zipari/shared-ds-util-status';
import { DisplayDay } from '../../calendar.model';

@Component({
  selector: 'lib-calendar-mobile-day-cell',
  templateUrl: './mobile-day-cell.component.html',
  styleUrls: ['./mobile-day-cell.component.scss'],
})
export class MobileDayCellComponent {
  @Input() singleDay: DisplayDay;
  @Input() statusses: ObjectStatuses;

  @Output() statusPillClicked = new EventEmitter<any>();
}
